import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getMemberships = () =>
  axiosInstance.get(`${LANDING_API_URL}/memberships`, {
    headers: authHeaders(),
  });

export const createMembershipRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/memberships`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateMembershipRequest = (membershipId, formData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/memberships/${membershipId}`,
    formData,
    {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    },
  );

export const removeMembership = (membershipId) =>
  axiosInstance.delete(`${LANDING_API_URL}/memberships/${membershipId}`, {
    headers: authHeaders(),
  });
